

export const iife = <T>(fn: () => T) => fn();